import { useEffect } from 'react';
import AppLoaderCircle from './AppLoaderCircle';
import { useTranslation } from 'react-i18next';

const AppLoader = () => {
  const { t } = useTranslation();
  useEffect(() => {
    const accessbilityElement = document.getElementById('INDWrap')?.style;
    if (accessbilityElement != undefined) {
      accessbilityElement.display = 'none';
    }

    return () => {
      if (accessbilityElement != undefined) {
        accessbilityElement.display = 'block';
      }
    };
  }, []);
  return (
    <div className='app-loader'>
      <div className='app-loader-top'>
        <div className='app-loader-brand'>
          {
            <>
              {t('helloLoader')}
              <br />
              {t('appTitle')}
            </>
          }
        </div>
        <AppLoaderCircle className='w-full h-full' />
      </div>
    </div>
  );
};

export default AppLoader;
